import * as yup from "yup";
import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { LookupAnswerTypeDto } from "../../../services/dto";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required."),
  description: yup.string().optional(),
});

interface AnswerTypeFromProps {
    data?: LookupAnswerTypeDto | undefined;
    show: boolean;
    onHide: () => void;
    onSave: (values: LookupAnswerTypeDto) => DrawerFormSaveResult;
}

export const AnswerTypeForm = (props: AnswerTypeFromProps) => {
  let answerType: LookupAnswerTypeDto | undefined = props.data;
  let title: string =
    StringHelper.whenNullOrEmpty(answerType?.id, Constants.emptyGuid) ===
    Constants.emptyGuid
      ? "New Answer Type"
      : "Edit Answer Type";

  const onSubmit = (data: LookupAnswerTypeDto) => {
    return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  const isNew = !answerType?.id || answerType?.id === Constants.emptyGuid;
  const isLoading = props.show && !isNew && !answerType;
  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      title={title}
      initialValues={answerType ?? {}}
      validationSchema={validationSchema}
      on_Submit={onSubmit}
    >
      <Form.Text
        name="name"
        placeholder="Enter text"
        label="Name"
        isLoading={isLoading}
      />
      <Form.TextArea
        name="description"
        rows={3}
        label="Description"
        isLoading={isLoading}
      />
    </Drawer.Form>
  );
};
